module.exports = __webpack_public_path__ + "img/play-circle.f0718487.svg";